import React from 'react'
import { supabase } from '@/lib/supabase'

const KEY = 'rewards.home.enabled'

export function useRewardsHomeEnabled() {
  const [enabled, setEnabled] = React.useState<boolean | null>(null)

  React.useEffect(() => {
    let mounted = true
    ;(async () => {
      try {
        const { data, error } = await supabase.from('app_settings').select('value').eq('key', KEY).maybeSingle()
        if (!mounted) return
        if (error) throw error
        const v = String((data as any)?.value || '').toLowerCase()
        setEnabled(v === 'true')
      } catch (e) {
        console.error('useRewardsHomeEnabled error', e)
        if (mounted) setEnabled(false)
      }
    })()
    return () => {
      mounted = false
    }
  }, [])

  return enabled
}

